import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    height: "100vh",
    background:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.68) -0.8%, rgba(0, 0, 0, 0.00) 30.3%, rgba(0, 0, 0, 0.53) 51.51%, rgba(0, 0, 0, 0.68) 99.01%)",
  },
  mediaFeed: {
    height: "100%",
    overflow: "hidden",
    zIndex: -1,
    position: "absolute",
    width: "100%",
  },
  content: {
    position: "absolute",
    bottom: 0,
    width: "100%",
  },
  mainContent: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    textAlign: "center",
    padding: `0${theme.spacing.space16}px `,
  },
  reward: {
    borderRadius: 8,
    background: "rgba(0, 0, 0, 0.49)",
    backdropFilter: "blur(2px)",
    padding: `${theme.spacing.space8}px ${theme.spacing.space20}px`,
    alignItems: "center",
    display: "flex",
    gap: 8,
  },
  cupIcon: {
    color: "#B3F50D",
  },
  esportsList: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    paddingTop: theme.spacing.space16,
  },
  esportIcon: {
    objectFit: "contain",
    maxWidth: 55,
  },
  button: {
    background: "#B3F50D",
    borderRadius: 100,
    display: "flex",
    width: "100%",
    justifyContent: "center",
    padding: theme.spacing.space12,
    border: "none",
  },
  arrowIcon: {
    color: theme.colors.TextSecondary,
    paddingLeft: theme.spacing.space8,
  },
  footerBottom: {
    padding: `${theme.spacing.space24}px ${theme.spacing.space16}px 100px`,
    width: "100%",
    boxSizing: "border-box",
    background:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.60) 26.5%, rgba(0, 0, 0, 0.50) 100%)",
  },
  featureIframe: {
    position: "fixed",
    width: "100vw",
    height: "100vh",
    zIndex: theme.zIndex.dialog + 1,
  },
}));
